import {
  GET_ADMIN_CALL_PRICES,
  GET_ADMIN_CALL_PRICES_SUCCESS,
  GET_ADMIN_CALL_PRICES_ERROR,
  UPDATE_ADMIN_CALL_PRICE,
  UPDATE_ADMIN_CALL_PRICE_SUCCESS,
  UPDATE_ADMIN_CALL_PRICE_ERROR
} from "./actionTypes"

const INIT_STATE = {
  admin_call_prices: [],
  error: null,
  loading: false,
}
const AdminCallPrices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_CALL_PRICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_ADMIN_CALL_PRICES_SUCCESS:
      return {
        ...state,
        error: null,
        admin_call_prices: action.payload,
        loading: false,
      }

    case GET_ADMIN_CALL_PRICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_ADMIN_CALL_PRICE:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_ADMIN_CALL_PRICE_SUCCESS:
      return {
        ...state,
        error: null,
        admin_call_prices: state.admin_call_prices.map((item) => (item.id === action.payload.id) ?  ({...item, ...action.payload}) : item),
        loading: false,
      }

    case UPDATE_ADMIN_CALL_PRICE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

export default AdminCallPrices;
